module.exports = __webpack_public_path__ + "img/mall1.a72e56df.png";